import React from "react";
import i18n from "../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import Et3PageTitle from "../../../core/et3-page-title/index";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import getCorePopUpStore from "../../../stores/core/core-popup-store";
import ET3PageDiv from "../../../core/et3-page-div";
import AccountsDeletionData from "./accounts-deletion-data";
import AccountsDeletionForm from "./accounts-deletion-form";
import Et3Margin from "../../../core/et3-ui/ET3Margin";

const AccountsDeletion = withLiteObserverAndTheme(() => {
  React.useEffect(() => {
    getCoreHistoryStore().setPageName(
      "COMMUNICATIONS_ACCOUNTS_DELETION",
      "COMMUNICATIONS_ACCOUNTS_DELETION"
    );
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("COMMUNICATIONS_ACCOUNTS_DELETION")}
        subTitle={i18n.get("VIEW_ACCOUNTS_DELETION_DATA")}
        withRefresh={false}
        withHelper={true}
        onPress={() => {
          getCorePopUpStore().showHelperMessage("ACCOUNT_DELETION_HELPER_TEXT");
        }}
      />
      <AccountsDeletionForm />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <AccountsDeletionData />
    </ET3PageDiv>
  );
});
export default AccountsDeletion;
